import React, { useEffect, useState , useCallback, useMemo} from 'react';
import { isMobile, isIOS  } from 'react-device-detect';
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useParams } from 'react-router-dom';
import { 
    getCurrentAccount,
    getRoleInCurrentClub,
    getCurrentClub,
    getGames,
    getProviders,
    getGameTags,
    getGameCategories,
    getSelectedCategory,
    getGameTypes,
    getGameUrls,
    getLiveCasinoGames,
} from "../../../../../store/selectors";
import '../../../../../assets/stylesheets/ClubSlide/PokerFrame.scss';
import { CloseHeader } from "./components";
import { LoadingPage } from "./components";
import { CategoryViewNavigation } from "./components";
import { CategoryViewGameList } from "./components";
import { requestGameUrl, removeGameUrl } from '../../../../../store/actionCreators/gameUrl';
import { setGameCategory } from '../../../../../store/actionCreators/gameCategories';
import gbParams from '../../../../../config/parameters';
const externalGameProviders = ['vivo'];

const externalGameIds = [14];

const CasinoTab = ({ isLeague, category }) => {
    /// TODO: get proper account for the current club
    const account = useSelector(getCurrentAccount);
    const roleInClub = useSelector(getRoleInCurrentClub);
    const gameUrls = useSelector(getGameUrls);

    const [search, setSearch] = useState('');
    const [type, setType] = useState('all');
    const [provider, setProvider] = useState('all');
    const [selectedGameTag, setGameTag] = useState('all');
    const [selectedExtendedProvider, setExtendedProvider] = useState('all');
    const [providers, setProviders] = useState([]);
    const [gameTags, setGameTags] = useState([]);
    const [gameId, setGameId] = useState();

    const [extendedProviders, setExtendedProviders] = useState([]);

    const selectedCategory = useSelector(getSelectedCategory);
    const categorizedProviders = useSelector(getProviders);
    const categorizedTags = useSelector(getGameTags);
    const gameTypes = useSelector(getGameTypes);
    const games = category === 'casino' ? useSelector(getGames) : useSelector(getLiveCasinoGames);
    const { levelExpDays } = useSelector(getCurrentClub);
    const [isFrameVisible, setIsFrameVisible] = useState(false);
    const [casinoUrl, setCasinoUrl] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        if( !!category ) {
            dispatch(setGameCategory(category));
        }
    }, [category]);

    useEffect(() => {
        if (!!selectedCategory && !!categorizedProviders[selectedCategory] && !!categorizedTags[selectedCategory]) {
            setProviders(categorizedProviders[selectedCategory]);
            setGameTags(categorizedTags[selectedCategory]);
            setExtendedProviders([...new Set([...categorizedProviders[selectedCategory], ...categorizedTags[selectedCategory]])]);
            setProvider("all");
            setGameTag("all");
        }
    }, [selectedCategory, categorizedProviders, categorizedTags]);

    const onSearchChange = useCallback(
        (e) => {
            if (e.target.value.match("^[A-z0-9 ]*$") != null) {
                setSearch(e.target.value);
            }
        }, [setSearch]
    );

    const onProviderChange = useCallback((prvd) => {
        setProvider(prvd);
      }, [provider, setProvider]);
    
    const onGameTagChange = useCallback((tag) => {
    // alert(JSON.stringify(e.currentTarget.dataset));
    setGameTag(tag);
    }, [selectedGameTag, setGameTag]);

    const onExtendedProviderChange = useCallback((extProvider) => {
    setExtendedProvider(extProvider);
    }, [selectedExtendedProvider, setExtendedProvider]);

    const onTypeChange = useCallback((e) => {
    const { key } = e.currentTarget.dataset;
    if (key === type) setType('all');
    else setType(key);
    }, [type, setType]);

    const filteredGames = useMemo(() => {
        let result = [...games]; // .filter((g) => g.category === id);
    
        // Filter by Extended Providers (providers+tags for now)
        // Used only for mobile
        //
        if (selectedExtendedProvider !== 'all') {
          result = result.filter((g) => g.provider.toString() === selectedExtendedProvider || g.tags.includes(selectedExtendedProvider));
        }
    
        // Filter by Provider
        //
        if (provider !== 'all') {
          result = result.filter((g) => g.provider.toString() === provider);
        }
    
        // Filter by Category
        //
        result = result.filter((g) => g.gameType === selectedCategory);
    
        // Filter by Tag
        //
        if (selectedGameTag !== 'all') {
          result = result.filter((g) => g.tags.includes(selectedGameTag));
        }
    
        // if (type !== 'all') {
        //   result = result.filter((g) => g.gametype === type);
        // }
    
        if (search) {
          const searchRegex = new RegExp(`(.*?)(${search})(.*?)`, 'gi');
          result = result.filter((g) => searchRegex.test(g.name));
        }
    
        // console.log('Filtered GAMES: ', result);
        return result;
      }, [games, providers, extendedProviders, gameTypes, search, provider, type, selectedGameTag, gameTags, selectedCategory, selectedExtendedProvider]);


    useEffect(() => {
        listenForWindowMessages();
    },[]);

    const openSlot = useCallback( url => {
        if(!url) return;
        if( isMobile ) {
            setCasinoUrl(url);
        } else {
            window.open(url, '', [
                'width=' + gbParams.dimensions.slot.width,
                'height=' + gbParams.dimensions.slot.height,
                'resizable=0',
                'scrollbars=1',
                'top=' + (window.screen.height - gbParams.dimensions.slot.height - 100) / 2,
                'left=' + (window.screen.width - gbParams.dimensions.slot.width) / 2
              ].toString());
        }
    });

    const requestSlotUrl = useCallback((slot) => {
        setGameId(slot.id);
        dispatch(requestGameUrl({ game: slot, isVirtual: false, isMobile }));
    },[gameId, gameUrls, account, setGameId]);

    useEffect(() => {
        if( !!gameUrls &&  !!gameId && !!gameUrls[gameId] ) {
            const selectedGame = games.find(game => game.id === gameId);
            if( externalGameProviders.includes(selectedGame.integrator) ) {
                window.location.href = gameUrls[gameId];
                return
            }
            openSlot( gameUrls[gameId] );
        }
    },[ gameUrls[gameId] ])

    const closeCasino = useCallback(() => {
        dispatch(removeGameUrl(gameId));
        setIsFrameVisible(false);
        setCasinoUrl('');
        setGameId();
    }, [gameId]);

    const showIFrame = useCallback((e) => {
        e.persist();
        setIsFrameVisible(true);
    }, []);

    const listenForWindowMessages = () => {
        window.addEventListener("message", e => {
            // console.log('EVENT DATA: ', e.data);
            if (e.data && e.data.name === "gameStatus") {
                switch (e.data.status) {
                    case "closed":
                        closeCasino();
                        break;
                    case "close":
                        closeCasino();
                        break;
                    case "initialized":
                        console.log('EVENT DATA: INITIALIZED');
                        break;
                    default:
                        break;
                }
            }else {
                const silverCasinoCloseMessages = ['close', 'closeGame', 'GAME_MODE:LOBBY'];
                if (silverCasinoCloseMessages.includes(e.data)) {
                    closeCasino();
                }
            }
        }, false);
    };

    return (
        <React.Fragment>

        <div className="category-view__nav">
            <CategoryViewNavigation
                providers={providers}
                provider={provider}
                selectedGameTag={selectedGameTag}
                gameTags={gameTags}
                search={search}
                onSearchChange={onSearchChange}
                onProviderChange={onProviderChange}
                onGameTagChange={onGameTagChange}
                setSearch={setSearch}
            />
        </div>

        <div className={`slot-list ${isLeague ? 'league' : ''}`}>
            {
                <CategoryViewGameList
                    games={filteredGames}
                    user={account}
                    requestSlotUrl={requestSlotUrl}
                />
            }
        </div>

            {
                casinoUrl &&
                <div className={`casinoFrame ${selectedCategory} ${isFrameVisible ? 'visible' : 'loading'}`}>
                    <CloseHeader onClose={() => closeCasino()}/>
                    {
                        !isFrameVisible ?
                            <LoadingPage
                                type={selectedCategory}
                                onClose={() => closeCasino()}
                            />
                            : false
                    }
                    <iframe 
                        src={casinoUrl}
                        onLoad={showIFrame}
                    />
                </div>
            }
            
        </React.Fragment>
    );
};

export default withRouter(CasinoTab);
